import { supabase, isSupabaseConfigured } from '@/integrations/supabase';

/**
 * Supabase Auth 세션 및 상태 변경 이벤트를 실시간으로 구독합니다.
 * @param {(event: string, session: any) => void} callback
 * @returns {{ unsubscribe: () => void }}
 */
export function subscribeAuthState(callback) {
  if (!isSupabaseConfigured) {
    return { unsubscribe: () => {} };
  }

  const {
    data: { subscription },
  } = supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session);
  });

  return {
    unsubscribe: () => {
      subscription.unsubscribe();
    },
  };
}
